module.exports = __webpack_public_path__ + "static/assets/837968234c2b73949129dcf823710cc8.svg";